import React from "react";
import Consultant from "../components/Consultant/Consultant";

const BookConsultant = () => {
  return <Consultant />;
};

export default BookConsultant;
